// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-items-table-vue[data-v-442edec3]{min-height:300px}.status-icon[data-v-442edec3]{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%}.status-expired[data-v-442edec3]{color:#ffc107}.status-denied[data-v-442edec3]{color:#dc3545}.text-limit[data-v-442edec3]{display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom}", ""]);
// Exports
module.exports = exports;
